// Draw from structured records so exports include every row and never capture site chrome.
export async function reportImage({ title, subtitle, headers, rows, footer }) {
  const widths = headers.length > 4 ? headers.map((_, i) => i === 0 ? 240 : i === headers.length - 1 ? 110 : 205) : headers.map((_, i) => i === 1 ? 420 : 190);
  const width = Math.max(900, widths.reduce((a, b) => a + b, 0) + 64);
  const rowHeight = 88;
  const tableTop = 180;
  const headerHeight = headers.length > 4 ? 140 : 56;
  const bodyTop = tableTop + headerHeight;
  const height = bodyTop + rows.length * rowHeight + 95;
  const canvas = document.createElement('canvas');
  canvas.width = width; canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, width, height);
  const text = (value, x, y, maxWidth, color = '#18334b', font = '20px Arial', maxLines = 3) => {
    ctx.fillStyle = color; ctx.font = font;
    const words = String(value).split(/\s+/); const lines = []; let line = '';
    for (const word of words) {
      if (ctx.measureText(line + word).width > maxWidth && line) { lines.push(line.trim()); line = ''; }
      line += word + ' ';
    }
    lines.push(line.trim());
    lines.slice(0, maxLines).forEach((l, i) => ctx.fillText(l, x, y + i * 24, maxWidth));
  };
  text('PICK EM  /  THE LEAGUE', 32, 45, width - 64, '#647c8c', 'bold 15px Arial');
  text(title, 32, 96, width - 64, '#18334b', 'bold 34px Arial');
  text(subtitle, 32, 142, width - 64, '#647c8c');
  ctx.fillStyle = '#f0f4f7'; ctx.fillRect(32, tableTop, width - 64, headerHeight);
  let x = 32;
  headers.forEach((h, i) => { text(h, x + 12, tableTop + 30, widths[i] - 24, '#40596d', 'bold 18px Arial', 5); x += widths[i]; });
  rows.forEach((row, index) => {
    const y = bodyTop + index * rowHeight; let left = 32;
    row.forEach((raw, col) => {
      const cell = typeof raw === 'object' ? raw : { text: raw };
      const w = widths[col];
      ctx.fillStyle = cell.result === 'win' ? '#b9dfce' : cell.result === 'loss' ? '#f6eded' : index % 2 ? '#f8fafb' : '#fff';
      ctx.fillRect(left + 3, y + 5, w - 6, rowHeight - 10);
      if (cell.lock) { ctx.strokeStyle = '#536d86'; ctx.lineWidth = 3; ctx.strokeRect(left + 4, y + 6, w - 8, rowHeight - 12); }
      text(cell.text, left + 12, y + 32, w - 24, '#18334b', col === 0 ? 'bold 19px Arial' : '19px Arial');
      left += w;
    });
  });
  text(footer, 32, height - 42, width - 64, '#647c8c', '16px Arial');
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Image could not be created.')), 'image/png'));
}

export function downloadFile(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a'); link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
